export default () => ({
  namespaced: true,
  state: {
    router: null
  },
  actions: {
    init ({ state }, { router }) {
      state.router = router
    },
    push ({ state }, to) {
      return state.router.push(to)
    },
    open (_, url) {
      document.location.href = url
    }
  }
})
